import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Ingredients from './pages/Ingredients';
import Packaging from './pages/Packaging';
import Recipes from './pages/Recipes';
import Products from './pages/Products';
import Channels from './pages/Channels';
import Analysis from './pages/Analysis';
import Production from './pages/Production';
import NewProduction from './pages/NewProduction';
import ProductionHistory from './pages/ProductionHistory';
import FidelityCustomers from './pages/FidelityCustomers';
import FidelityRewards from './pages/FidelityRewards';
import FidelityScanner from './pages/FidelityScanner';
import FidelityRedemptions from './pages/FidelityRedemptions';
import FidelityPublic from './pages/FidelityPublic';
import UserManagement from './pages/UserManagement';
import NotificationManager from './pages/NotificationManager';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/fidelity" element={<FidelityPublic />} />
            
            {/* Protected routes */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
                    <Navigation />
                    <main className="container mx-auto px-4 py-8">
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/ingredients" element={<Ingredients />} />
                        <Route path="/packaging" element={<Packaging />} />
                        <Route path="/recipes" element={<Recipes />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/channels" element={<Channels />} />
                        <Route path="/production" element={<Production />} />
                        <Route path="/analysis" element={<Analysis />} />
                        <Route path="/fidelity/customers" element={<FidelityCustomers />} />
                        <Route path="/fidelity/rewards" element={<FidelityRewards />} />
                        <Route path="/fidelity/scanner" element={<FidelityScanner />} />
                        <Route path="/fidelity/redemptions" element={<FidelityRedemptions />} />
                        <Route path="/users" element={<UserManagement />} />
                        <Route path="/notifications" element={<NotificationManager />} />
                        <Route path="/productions/new" element={<NewProduction />} />
                        <Route path="/productions/history" element={<ProductionHistory />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </main>
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;